<template>
  <div class="version-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
    <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">
      <a-form-model-item label="版本号" prop="name">
        <a-input v-model="form.name" placeholder="请输入版本号，格式必须为x.x.x" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="系统平台" prop="platform">
        <a-radio-group v-model="form.platform">
          <a-radio :value="1">IOS</a-radio>
          <a-radio :value="2">Android</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="更新类型" prop="type">
        <a-radio-group v-model="form.type">
          <a-radio :value="1">必须</a-radio>
          <a-radio :value="3">非必须</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="终端" prop="terminal">
        <a-radio-group v-model="form.terminal">
          <a-radio value="owner">住户端</a-radio>
          <a-radio value="property">物业端</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="下载地址" prop="url">
        <a-input v-model="form.url" placeholder="请输入下载地址" allow-clear></a-input>
      </a-form-model-item>
      <a-form-model-item label="发布时间" prop="date">
        <a-date-picker v-model="form.date" show-time placeholder="请选择发布时间" valueFormat="YYYY-MM-DD HH:mm:ss"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="版本备注" prop="note">
        <a-textarea v-model="form.note" placeholder="请输入版本备注"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
        <a-space>
          <a-button type="primary" @click="submit">提交</a-button>
          <a-button @click="cancel">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
  import VersionService from '@/io/version.js';

  export default {
    name: 'VersionInfo',
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: null,
          platform: null,
          type: null,
          terminal: null,
          url: null,
          date: null,
          note: null
        },
        rules: {
          name: [
            {
              required: true,
              message: '请输入版本号'
            }
          ],
          platform: [
            {
              required: true,
              message: '请选择系统平台'
            }
          ],
          type: [
            {
              required: true,
              message: '请选择更新类型'
            }
          ],
          terminal: [
            {
              required: true,
              message: '请选择终端'
            }
          ],
          url: [
            {
              required: true,
              message: '请输入下载地址'
            }
          ],
          date: [
            {
              required: true,
              message: '请选择发布时间'
            }
          ],
          note: [
            {
              required: true,
              message: '请输入版本备注'
            }
          ]
        }
      }
    },
    mounted () {
      this.initPage();
    },
    methods: {
      initPage() {
        if (this.id) {
          VersionService.info(this.id).then(res => {
            this.form.name = res.version;
            this.form.platform = res.platform;
            this.form.type = res.update_state;
            this.form.terminal = res.terminal;
            this.form.url = res.download_url;
            this.form.date = res.publish_time;
            this.form.note = res.description;
          }).catch(err => {});
        }
      },
      submit() {
        this.$beforeFormSubmit(this.$refs.form, () => {
          if (this.id) {
            VersionService.edit(
              this.id,
              this.form.name,
              this.form.platform,
              this.form.type,
              this.form.terminal,
              this.form.url,
              this.form.date,
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('编辑成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          } else {
            VersionService.add(
              this.form.name,
              this.form.platform,
              this.form.type,
              this.form.terminal,
              this.form.url,
              this.form.date,
              this.form.note
            ).then(res => {
              this.$afterFormSubmit('创建成功', () => {
                this.cancel();
              });
            }).catch(err => {});
          }
        });
      },
      cancel() {
        this.$router.push('/platform/version_manage');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>